import { message } from 'antd'
import { getPermisosMenuUsuarios } from './usuario'

export async function getMenuDataByUsuarioId(usuarioId) {
  // Función para ordenar los datos del árbol por título
  const ordernarDatos = menuData => {
    return menuData
      .map(item => ({
        ...item,
        children: item.children ? ordernarDatos(item.children) : null,
      }))
      .sort((a, b) => a.title.localeCompare(b.title))
  }

  // Se transforma el menu en lo que espera la plantilla
  function transformData(menuData) {
    const menuOrdenado = ordernarDatos(menuData)
    const result = []

    menuOrdenado.forEach(item => {
      if (item.category) {
        result.push({
          category: item.category,
          title: item.title,
        })
      }
      result.push({
        ...item,
        children: item.children ? transformData(item.children) : null,
      })
    })

    return result
  }

  try {
    const result = await getPermisosMenuUsuarios(usuarioId)
    if (result?.ok) {
      const menuFinalizado = transformData(result?.data)
      return menuFinalizado
    }
    message.error('No se ha podido cargar los permisos.')
  } catch (error) {
    message.error(error.message)
  }
  return []
}

// *** Esta función está deprecated ***
export default async function getMenuData() {
  return [
    /*

    {
      category: true,
      title: 'Dashboards',
    },
    {
      title: 'Dashboards',
      key: 'dashboards',
      icon: 'fe fe-home',
      // roles: ['admin'], // set user roles with access to this route
      count: 4,
      children: [
        {
          title: 'Dashboard Alpha',
          key: 'dashboard',
          url: '/dashboard/alpha',
        },
        {
          title: 'Dashboard Beta',
          key: 'dashboardBeta',
          url: '/dashboard/beta',
        },
        {
          title: 'Dashboard Gamma',
          key: 'dashboardGamma',
          url: '/dashboard/gamma',
        },
        {
          title: 'Crypto Terminal',
          key: 'dashboardCrypto',
          url: '/dashboard/crypto',
        },
      ],
    }, */
    {
      category: true,
      title: 'Administración',
    },
    {
      title: 'Administración',
      key: 'administracion',
      icon: 'fas fa-key',
      children: [
        {
          title: 'Carteles ',
          key: 'carteles',
          url: '/carteles/list',
          icon: 'fas fa-image',
        },
        {
          title: 'Consulta Email ',
          key: 'consultaEmail',
          url: '/consultaEmail/list',
          icon: 'far fa-envelope',
        },
        {
          title: 'Menú Banner ',
          key: 'menuBanner',
          url: '/banner/list',
          icon: 'fas fa-bars',
        },
        {
          title: 'Menú Categorias ',
          key: 'menuCategorias',
          icon: 'fas fa-th-large',
          disabled: true,
          children: [
            {
              title: 'Configuración',
              key: 'menuCategoriasConfig',
              url: '/categoriaHome/configuracion',
            },
            {
              title: 'Selección',
              key: 'menuCategoriasSeleccion',
              url: '/categoriaHome/menu',
            },
          ],
        },
        {
          title: 'Menú Productos Semana ',
          key: 'menuProductosSemana',
          url: '/productosSemana/menu',
          icon: 'fas fa-tasks',
        },
        {
          title: 'Menú Sitio ',
          key: 'menuSitio',
          url: '/menuSitio/list',
          icon: 'fas fa-list',
        },
        {
          title: 'Usuarios Admin',
          key: 'usuariosadmin',
          icon: 'fas fa-key',
          children: [
            {
              title: 'Usuarios',
              key: 'Usuarios',
              url: '/usuariosAdmin/usuarios/list',
              icon: 'fas fa-image',
            },
            {
              title: 'Estados de Usuarios',
              key: 'estadoUsuarios',
              url: '/estadosUsuarios/list',
              icon: 'far fa-comment',
            },
            {
              title: 'Roles',
              key: 'roles',
              url: '/roles/list',
              icon: 'fas fa-users',
            },
          ],
        },
      ],
    },
    {
      category: true,
      title: 'Configuraciones',
    },
    {
      title: 'Configuraciones',
      key: 'configuraciones',
      icon: 'fas fa-cog',
      children: [
        {
          title: 'Caso 3 Bis ',
          key: 'caso3bis',
          url: '/caso3bis/list',
          icon: 'far fa-calendar-plus',
        },
        {
          title: 'Corte de Personalización ',
          key: 'cortePersonalizacion',
          url: '/fechasNoEntrega/categoriaPersonalizacionDiaria',
          icon: 'fas fa-cut',
        },
        {
          title: 'Fechas Bloqueadas ',
          key: 'fechasBloqueadas',
          url: '/fechasBloqueadas/list',
          icon: 'far fa-calendar-minus',
        },
        {
          title: 'Fechas No Entrega ',
          key: 'fechasNoEntrega',
          url: '/fechasNoEntrega/list',
          icon: 'far fa-calendar-times',
        },
        {
          title: 'Estados ',
          key: 'estados',
          url: '/estados/list',
          icon: 'fas fa-list-ol',
        },
        {
          title: 'Estados Bultos ',
          key: 'estadosBultos',
          url: '/estadosBultos/list',
          icon: 'fas fa-list-ol',
        },
        {
          title: 'Estados Mensajeria ',
          key: 'estadosMensajeria',
          url: '/estadosMensajeria/list',
          icon: 'fas fa-list-ul',
        },
        {
          title: 'Estanterias Crear ',
          key: 'estanteriasCrear',
          url: '/estanterias/list',
          icon: 'fas fa-th',
        },
        {
          title: 'Separar Personalizado ',
          key: 'separar-personalizado',
          url: '/estanterias/separar-personalizado',
          icon: 'fas fa-archive',
        },
        {
          title: 'Estanteria Diseño Mixta ',
          key: 'estanteria-diseno-mixta',
          url: '/estanterias/estanteria-diseno-mixta',
          icon: 'far fa-object-ungroup',
        },
        {
          title: 'Control Diseño ',
          key: 'control-diseno',
          url: '/control-diseno/control',
          icon: 'far fa-check-square',
        },
        {
          title: 'Control Diseño Mantas ',
          key: 'control-diseno-mantas',
          url: '/control-diseno-mantas/list',
          icon: 'fas fa-check',
        },
        {
          title: 'Paises ',
          key: 'paises',
          url: '/paises/list',
          icon: 'fas fa-globe',
        },
        {
          title: 'Provincias ',
          key: 'provincias',
          url: '/provincias/list',
          icon: 'far fa-map',
        },
        {
          title: 'Relación Horarios Madrid MRW ',
          key: 'horarioEntregaMadrid',
          url: '/horarioEntregaMadrid/list',
          icon: 'far fa-clock',
        },
        {
          title: 'Descuentos',
          key: 'descuentos',
          url: '/descuentos/list',
          icon: 'fas fa-percent',
        },
        {
          title: 'Imagenes Descuentos Reporte',
          key: 'imagenDescuentos',
          url: '/imagen-descuento/list',
          icon: 'far fa-file-image',
        },
        {
          title: 'Observaciones',
          key: 'observaciones',
          url: '/observaciones/list',
          icon: 'fas fa-list-ul',
        },
        {
          title: 'Colores Lego',
          key: 'coloresLego',
          url: '/colorlego/list',
          icon: 'fas fa-palette',
        },
        {
          title: 'Descripciones IVA',
          key: 'descriocionesIva',
          url: '/descripcionesIva/list',
          icon: 'fas fa-gavel',
        },
        {
          title: 'Departamentos',
          key: 'departamentos',
          url: '/departamentos/list',
          icon: 'fas fa-building',
        },
      ],
    },
    {
      category: true,
      title: 'Envíos',
    },
    {
      title: 'Envíos',
      key: 'envios',
      icon: 'fas fa-rocket',
      children: [
        {
          title: 'Dhl transmitir Aéreo',
          key: 'dhlAereoTransmitir',
          url: '/dhl/list/aereo',
          icon: 'fas fa-space-shuttle',
        },
        {
          title: 'Dhl transmitir Terrestre',
          key: 'dhlTerrestreTransmitir',
          url: '/dhl/list/terrestre',
          icon: 'fas fa-truck',
        },
        {
          title: 'Seur transmitir Filtros ',
          key: 'seurTransmitir',
          url: '/seur/list',
          icon: 'fas fa-truck',
        },
        {
          title: 'Correos Express transmitir Filtros ',
          key: 'correosExpressTransmitir',
          url: '/correosExpress/list',
          icon: 'fas fa-plane',
        },
        {
          title: 'Mrw transmitir Diurnos  ',
          key: 'mrwTransmitirDiurno',
          url: '/mrwClick/list/3',
          icon: 'fas fa-bus',
        },
        {
          title: 'Mrw transmitir Ecommerce  ',
          key: 'mrwTransmitirEcommerce',
          url: '/mrwClick/list/1',
          icon: 'fas fa-bus',
        },
        {
          title: 'Mrw transmitir Urgentes  ',
          key: 'mrwTransmitirUrgente',
          url: '/mrwClick/list/2',
          icon: 'fas fa-bus',
        },
        {
          title: 'Mrw transmitir Ecommerce Tramo  ',
          key: 'mrwTransmitirEcommerceTramo',
          url: '/mrwClick/list/4',
          icon: 'fas fa-bus',
        },
        {
          title: 'Reclamaciones Mrw',
          key: 'mrwReclamaciones',
          url: '/reclamaciones-mrw/',
          icon: 'fas fa-bus',
        },
        {
          title: 'Mensajeros',
          key: 'mensajeros',
          url: '/Mensajeros/list',
          icon: 'fas fa-truck',
        },
        {
          title: 'Recorridos',
          key: 'recorridos',
          url: '/Mensajeros/recorridos',
          icon: 'fas fa-map-marker-alt',
        },
        {
          title: 'Separar Pedidos',
          key: 'separarPedidos',
          url: '/Mensajeros/separarPedidos',
          icon: 'fas fa-gift',
        },
        {
          title: 'Histórico Recorridos',
          key: 'historicoRecorridos',
          url: '/Mensajeros/historico',
          icon: 'fas fa-history',
        },
      ],
    },

    {
      title: 'Reportes',
      key: 'reportes',
      icon: 'fas fa-chart-bar',
      children: [
        {
          title: 'Etiquetas Comida',
          key: 'etiquetasComidas',
          url: '/reportes/etiquetasComidas/list/',
          // icon: 'fas fa-user-circle',
        },
        {
          title: 'Productos Preparados',
          key: 'productosPreparados',
          url: '/repostes/productos-preparados',
          // icon: 'fas fa-check-circle',
        },
        {
          title: 'Registros Pedidos',
          key: 'registrosPedidos',
          url: '/reportes/registros-pedidos/',
          // icon: 'far fa-circle',
        },
        {
          title: 'Usuarios Venta Preparados',
          key: 'usuariosVentaPreparados',
          url: '/reportes/usuarios-venta-preparados/',
          // icon: 'far fa-user-circle',
        },
        {
          title: 'Usuarios Venta Bandeja',
          key: 'usuariosVentaBandeja',
          url: '/reportes/usuarios-venta-bandeja/',
          // icon: 'fas fa-user-circle',
        },
        {
          title: 'Lotes Impresión',
          key: 'lotesImpresion',
          url: '/reportes/lotes-impresion/list',
          // icon: 'fas fa-user-circle',
        },
        {
          title: 'Comparación facturación años anteriores',
          key: 'compararfacturacion',
          url: '/reportes/compararfacturacion/list',
          // icon: 'fas fa-user-circle',
        },
        {
          title: 'Listado de Faltantes',
          key: 'listadofaltantes',
          url: '/reportes/listadoFaltantes/list',
          // icon: 'fas fa-user-circle',
        },
        {
          title: 'Listado de Frutas Pendientes de Compra',
          key: 'listadofrutaspendientescompra',
          url: '/reportes/listadoFrutasPendientesCompra/list',
          // icon: 'fas fa-user-circle',
        },
        {
          title: 'Listado de Ramos Vendidos',
          key: 'listadoproductoramosvendidos',
          url: '/reportes/listado-producto-ramos-vendidos/list',
          // icon: 'fas fa-user-circle',
        },
        {
          title: 'Listado Url Activas No Traducidas',
          key: 'listadourlactivasnotraducidas',
          url: '/reportes/listado-url-activas-no-traducidas/list',
          // icon: 'fas fa-user-circle',
        },
        {
          title: 'Productos Vendidos',
          key: 'listadoproductovendidos',
          url: '/reportes/listado-producto-vendidos/list',
          // icon: 'fas fa-user-circle',
        },
        {
          title: 'Productos Vendidos Url',
          key: 'listadoproductovendidosurl',
          url: '/reportes/listado-producto-vendidos-url/list',
          // icon: 'fas fa-user-circle',
        },
        {
          title: 'Productos Fabricados',
          key: 'listadoproductofabricados',
          url: '/reportes/listado-productos-fabricados/list',
          // icon: 'fas fa-user-circle',
        },
      ],
    },

    {
      title: 'Check Bultos',
      key: 'checkBultos',
      url: '/reportes/check-bultos/',
      icon: 'fas fa-user-circle',
    },

    {
      title: 'Tildar Bultos',
      key: 'tildarBultos',
      url: '/reportes/tildar-bultos/',
      icon: 'fas fa-user-circle',
    },

    {
      category: true,
      title: 'Pago On-Line',
    },
    {
      title: 'Pago On-Line',
      key: 'pagoOnline',
      icon: 'fas fa-credit-card',
      children: [
        {
          title: 'Códigos Postales  ',
          key: 'codigoPostal',
          url: '/codigoPostal/list',
          icon: 'fas fa-map-signs',
        },
        {
          title: 'CP Conflictivos  ',
          key: 'codigosPostalesConflictivos',
          url: '/codigosPostalesConflictivos/list',
          icon: 'fas fa-exclamation-triangle',
        },
        {
          title: 'CP Internacional  ',
          key: 'codigosPostalesInternacionales',
          url: '/codigosPostalesInternacionales/list',
          icon: 'fas fa-plane',
        },
        {
          title: 'Días Especiales  ',
          key: 'diasEspeciales',
          url: '/diasEspeciales/list',
          icon: 'fas fa-calendar',
        },
      ],
    },
    {
      category: true,
      title: 'Productos',
    },
    {
      title: 'Productos',
      key: 'productosParent',
      icon: 'fas fa-sitemap',
      children: [
        {
          title: 'Productos Genéricos',
          key: 'productosGenericos',
          url: '/productogenerico/list',
          icon: 'fas fa-cart-arrow-down',
        },
        {
          title: 'Artículos ',
          key: 'articulos',
          url: '/articulos/list',
          icon: 'fas fa-cart-arrow-down',
        },
        {
          title: 'Alta de Stock ',
          key: 'stock',
          url: '/articulos/stock',
          icon: 'fas fa-cart-arrow-down',
        },
        {
          title: 'Artículos Faltantes ',
          key: 'articulosFaltantes',
          url: '/articulos/sinStock',
          icon: 'fas fa-cart-plus',
        },
        {
          title: 'Artículos Vendidos ',
          key: 'articulosVendidos',
          url: '/articulos/vendidos',
          icon: 'fas fa-cart-plus',
        },
        {
          title: 'Categorias ',
          key: 'categorias',
          url: '/categorias/list',
          icon: 'fas fa-list-alt',
        },
        {
          title: 'Categorias Personalización ',
          key: 'categoriasPersonalizacion',
          url: '/categoriaPersonalizados/list',
          icon: 'far fa-object-group',
        },
        {
          title: 'Categorias Stickers',
          key: 'categoriasStickers',
          url: '/stickers/categorias/list',
          icon: 'fas fa-sticky-note',
        },
        {
          title: 'Frutas ',
          key: 'frutas',
          url: '/frutas/list',
          icon: 'far fa-lemon',
        },
        {
          title: 'Productos ',
          key: 'productos',
          url: '/productos/list',
          icon: 'fab fa-product-hunt',
        },
        {
          title: 'Productos Desayuno',
          key: 'productosDesayuno',
          url: '/productosdesayuno/list',
          icon: 'fas fa-coffee',
        },
        {
          title: 'Productos En Caja',
          key: 'productosEnCaja',
          url: '/productosencaja/list',
          icon: 'fas fa-archive',
        },
        {
          title: 'Proveedores ',
          key: 'proveedores',
          url: '/proveedores/list',
          icon: 'fas fa-cubes',
        },
        {
          title: 'Personalización',
          key: 'personalizacion',
          icon: 'fas fa-book',
          children: [
            {
              title: 'Bibliotecas Prediseños SVG',
              key: 'bibliotecasPredSvg',
              url: '/bibpredsvg/list',
              icon: 'fas fa-book',
            },
            {
              title: 'Bibliotecas de Plantillas',
              key: 'bibliotecasPlantillas',
              url: '/bibplantilla/list',
              icon: 'fas fa-book',
            },
            {
              title: 'Biblioteca de Precios',
              key: 'bibliotecasPrecios',
              url: '/bibprecios/list',
              icon: 'fas fa-book',
            },
            {
              title: 'Bibliotecas de Preguntas',
              key: 'bibliotecasPreguntas',
              url: '/bibpregunta/list',
              icon: 'fas fa-book',
            },
            {
              title: 'Bibliotecas de Familias',
              key: 'bibliotecasFamilias',
              url: '/bibfamilia/list',
              icon: 'fas fa-book',
            },
            {
              title: 'Bibliotecas de Fondos Familias',
              key: 'bibliotecasFamiliasFondos',
              url: '/bibfondofamilia/list',
              icon: 'fas fa-book',
            },
          ],
        },
        {
          title: 'Combos SVG',
          key: 'combosSvg',
          url: '/combossvg/list',
          icon: 'fas fa-book',
        },
        {
          title: 'Tipo Letra',
          key: 'tipoLetras',
          url: '/fonts/list',
          icon: 'fas fa-font',
        },
        {
          title: 'Productos Mas Vendidos',
          key: 'productosMasVendidos',
          url: '/productosMasVendidos/',
          icon: 'fas fa-chart-line',
        },
      ],
    },
    {
      category: true,
      title: 'Site Maker',
    },
    {
      title: 'Site Maker',
      key: 'siteMaker',
      icon: 'fas fa-desktop',
      children: [
        {
          title: 'Etiquetas ',
          key: 'etiquetas',
          url: '/etiquetas/list',
          icon: 'fas fa-ticket-alt',
        },
        {
          title: 'Fechas Color ',
          key: 'fechasColor',
          url: '/fechaColor/list',
          icon: 'far fa-calendar',
        },
        {
          title: 'Fechas Señaladas ',
          key: 'fechasSenaladas',
          url: '/fechaSenalada/list',
          icon: 'far fa-calendar-check',
        },
        {
          title: 'Franja Horarios ',
          key: 'franjasHorarios',
          url: '/franjaHorario/list',
          icon: 'far fa-calendar-minus',
        },
        {
          title: 'URL ',
          key: 'urls',
          url: '/urls/list',
          icon: 'fas fa-code',
        },
        {
          title: 'URL Grupos ',
          key: 'urlGrupos',
          url: '/urlGrupos/list',
          icon: 'fas fa-angle-double-right',
        },
        {
          title: 'URL Grupos Diseño',
          key: 'urlGruposDiseno',
          url: '/urlGruposDiseno/list',
          icon: 'fas fa-angle-double-right',
        },
        {
          title: 'Traducciones Urls ',
          key: 'traduccionPagina',
          url: '/traduccionPagina/list',
          icon: 'fas fa-language',
        },
        {
          title: 'Recuperar URL ',
          key: 'recuperarUrls',
          url: '/urls/recuperar',
          icon: 'fas fa-code',
        },
        {
          title: 'Generar Mapa ',
          key: 'generarMapa',
          url: '/generarMapa/list',
          icon: 'fas fa-map',
        },
      ],
    },
    {
      category: true,
      title: 'Templates',
    },
    {
      title: 'Templates',
      key: 'templates',
      icon: 'fas fa-tv',
      children: [
        {
          title: 'Página OK ',
          key: 'paginaOk',
          url: '/paginaOkTemplate/list',
          icon: 'fab fa-wpforms',
        },
        {
          title: 'Mails ',
          key: 'mails',
          url: '/mailTemplate/list',
          icon: 'far fa-envelope',
        },
      ],
    },
    {
      title: 'Ventas',
      key: 'ventasagrupados',
      icon: 'fas fa-shopping-cart',
      children: [
        {
          category: false,
          title: 'Ventas',
          key: 'ventas',
          icon: 'fas fa-shopping-cart',
          url: '/ventas/list',
        },
        {
          category: false,
          title: 'Pedidos masivos',
          key: 'ventasmasiva',
          icon: 'fas fa-cart-plus',
          url: '/ventasmasiva/list',
        },
        {
          category: false,
          title: 'Devoluciones',
          key: 'devoluciones',
          icon: 'fas fa-money-bill-wave',
          url: '/devoluciones/list',
        },
        {
          category: false,
          title: 'Importar Amazon',
          key: 'amazon',
          icon: 'fab fa-amazon',
          url: '/ventas/amazon/list',
        },
        {
          category: false,
          title: 'Recogidas en tienda',
          key: 'recogidasTienda',
          icon: 'fas fa-store',
          url: '/ventas/recogidas-tienda',
        },
      ],
    },
    {
      category: true,
      title: 'Envíos',
    },
    {
      title: 'Avatares',
      key: 'avatares',
      icon: 'fas fa-user',
      children: [
        {
          title: 'Galería de Cliente ',
          key: 'clienteAvatares',
          url: '/avatares/cliente/list',
          icon: 'fas fa-id-badge',
        },
        {
          title: 'Familias ',
          key: 'listaAvatares',
          url: '/avatares/list',
          icon: 'fas fa-list-ul',
        },
        {
          title: 'Plantillas ',
          key: 'templateAvatares',
          url: '/avatares/plantilla/list',
          icon: 'far fa-object-group',
        },
        {
          title: 'Secciones ',
          key: 'seccionesAvatares',
          url: '/avatares/seccion/list',
          icon: 'fas fa-th',
        },
        {
          title: 'Tamaños ',
          key: 'sizeAvatares',
          url: '/avatares/size/list',
          icon: 'fas fa-expand-alt',
        },
        {
          title: 'Capas ',
          key: 'layerAvatares',
          url: '/avatares/layer/list',
          icon: 'far fa-sticky-note',
        },
        {
          title: 'Colores ',
          key: 'coloresAvatares',
          url: '/avatares/paleta/list',
          icon: 'fas fa-tint',
        },
        {
          title: 'Stock Piezas',
          key: 'stockPiezas',
          url: '/avatares/piezas/list',
          icon: 'fas fa-puzzle-piece',
        },
      ],
    },
    {
      title: 'Bandejas',
      key: 'bandejas',
      icon: 'fas fa-archive',
      children: [
        {
          title: 'Ver Bandejas ',
          key: 'verBandejas',
          url: '/bandejas/list',
          icon: 'fas fa-archive',
        },
        {
          title: 'Tildar Bandejas ',
          key: 'tildarBandejas',
          url: '/estanterias/tildar',
          icon: 'fas fa-barcode',
        },
      ],
    },
    {
      category: false,
      title: 'Cache',
      key: 'cache',
      icon: 'fas fa-database',
      url: '/cache/list',
    },
    {
      category: false,
      title: 'Jobs',
      key: 'jobs',
      icon: 'fas fa-cubes',
      children: [
        {
          title: 'Logs de Jobs',
          key: 'jobsList',
          url: '/jobs/list',
          icon: 'fas fa-list',
        },
        {
          title: 'Gestión de Jobs',
          key: 'jobsManagement',
          url: '/jobs/management',
          icon: 'fas fa-cogs',
        },
      ],
    },
    {
      category: false,
      title: 'Sync',
      key: 'sync',
      icon: 'fas fa-sync',
      url: '/sync/list',
    },
    {
      category: false,
      title: 'Ladrones',
      key: 'ladrones',
      icon: 'fas fa-user-secret',
      url: '/ladrones/list',
    },
  ]
}
